// components/CustomCalendar.js
import React, { useEffect, useRef } from 'react';
import { Calendar } from "react-date-range";

export const CustomCalendar = (props) => {
  const calendarRef = useRef(null);

  useEffect(() => {

    const timer = setTimeout(() => {
      const monthElement = document.querySelector('.rdrMonthName');
      if (monthElement && monthElement.textContent.includes('2021')) {

        const scrollContainer = document.querySelector('.rdrInfiniteMonths');
        if (scrollContainer && props.date) {
          const currentYear = new Date().getFullYear();
          const monthsSince2021 = (currentYear - 2021) * 12;
          const approximateScrollPosition = monthsSince2021 * 220;
          
          scrollContainer.scrollTop = approximateScrollPosition;
        }
      }
    }, 50);
    
    return () => clearTimeout(timer);
  }, [props.date]);
  
  return (
    <Calendar
      ref={calendarRef}
      {...props}
      scroll={props.scroll || { enabled: false }}

    />
  );
};
